// extracted by mini-css-extract-plugin
export default {"jackpot":"GameJackpot__jackpot--3w_","infoIcon":"GameJackpot__infoIcon--1wf","title":"GameJackpot__title--2VT"};